import { render, staticRenderFns } from "./ProjetoCadastro.vue?vue&type=template&id=57f7609d&"
import script from "./ProjetoCadastro.vue?vue&type=script&lang=js&"
export * from "./ProjetoCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports